import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, ListGroup, ListGroupItem } from "reactstrap";

const InfoButtonWithModal = ({ data, id = "InfoButton" }) => {
    const [modalOpen, setModalOpen] = useState(false);

    const toggleModal = () => setModalOpen(!modalOpen);

    const formatTooltipData = () => {
        return Object.entries(data || {}).map(([key, value]) => ({
            key: key.charAt(0).toUpperCase() + key.slice(1), // Capitalize the first letter of each key
            value,
        }));
    };

    return (
        <>
            <button
      type="button"
                className="btn-link p-0 border-0 bg-transparent me-1"
      id={id}
      onClick={toggleModal}
    >
      <i className="ri-information-line text-primary" style={{ fontSize: '14px' }}></i>
    </button>

            <Modal isOpen={modalOpen} toggle={toggleModal} size="lg">
                <ModalHeader toggle={toggleModal}>Information</ModalHeader>
                <ModalBody>
                    {data && (
                        <ListGroup>
                            {formatTooltipData().map(({ key, value }, index) => (
                                <ListGroupItem key={index} className="d-flex justify-content-between align-items-center">
                                    <strong>{key}:</strong>
                                    <span>{value}</span>
                                </ListGroupItem>
                            ))}
                        </ListGroup>
                    )}
                </ModalBody>
                
            </Modal>
        </>
    );
};

export default InfoButtonWithModal;
